import { RiskRange, RiskRanges } from "../ranges";
import { Risk, Sex } from "../units";

function rangesFor({
  sex,
  age,
  isScore2HighRisk,
}: {
  sex: Sex;
  age: number;
  isScore2HighRisk: boolean;
}): RiskRanges<"mmol/L"> {
  const optimalRange: RiskRange = isScore2HighRisk
    ? { from: 1.0, to: 3.4, risk: Risk.Optimal, label: "optimal" }
    : { from: 1.0, to: 4.0, risk: Risk.Optimal, label: "optimal" };

  if (sex === Sex.Male) {
    if (age > 50) {
      return new RiskRanges("mmol/L", [
        optimalRange,
        { from: optimalRange.to, to: 6.2, risk: Risk.Normal, label: "normal" },
        { from: 6.2, to: 8.5, risk: Risk.HighRisk, label: "high" },
      ]);
    }

    if (age >= 30) {
      return new RiskRanges("mmol/L", [
        optimalRange,
        { from: optimalRange.to, to: 6.1, risk: Risk.Normal, label: "normal" },
        { from: 6.1, to: 8.5, risk: Risk.HighRisk, label: "high" },
      ]);
    }

    if (age >= 18) {
      return new RiskRanges("mmol/L", [
        optimalRange,
        { from: optimalRange.to, to: 5.0, risk: Risk.Normal, label: "normal" },
        { from: 5.0, to: 8.5, risk: Risk.HighRisk, label: "high" },
      ]);
    }
  }

  if (sex === Sex.Female) {
    if (age > 50) {
      return new RiskRanges("mmol/L", [
        optimalRange,
        { from: optimalRange.to, to: 6.2, risk: Risk.Normal, label: "normal" },
        { from: 6.2, to: 8.5, risk: Risk.HighRisk, label: "high" },
      ]);
    }

    if (age >= 30) {
      return new RiskRanges("mmol/L", [
        optimalRange,
        { from: optimalRange.to, to: 5.1, risk: Risk.Normal, label: "normal" },
        { from: 5.1, to: 8.5, risk: Risk.HighRisk, label: "high" },
      ]);
    }

    if (age >= 18) {
      return new RiskRanges("mmol/L", [
        optimalRange,
        { from: optimalRange.to, to: 4.7, risk: Risk.Normal, label: "normal" },
        { from: 4.7, to: 8.5, risk: Risk.HighRisk, label: "high" },
      ]);
    }
  }

  return new RiskRanges("mmol/L", []);
}

export const NonHDL = {
  rangesFor,
};
